import React from 'react';
import { getContext } from 'common';
import Checkbox, { CheckboxProps } from 'components/Checkbox';
import Styled from './styles';

export interface TreeCheckboxProps extends React.ComponentPropsWithRef<'div'> {
  /** Override `Checkbox` props. */
  checkboxProps?: Partial<CheckboxProps>;
}

/** A component to use as a Checkbox in a tree item. All other props will be provided to the wrapper. */
const TreeCheckbox = React.forwardRef<HTMLElement, TreeCheckboxProps>((props: TreeCheckboxProps, ref) => getContext(({ RTL }) => {
  const {
    checkboxProps,
    ...otherProps
  } = props;

  return (
    <Styled.TreeCheckbox RTL={RTL} {...otherProps}>
      <Checkbox
        ref={ref}
        {...checkboxProps}
      />
    </Styled.TreeCheckbox>
  );
}));

TreeCheckbox.displayName = 'TreeCheckbox';

TreeCheckbox.defaultProps = {
  checkboxProps: {},
};

export default TreeCheckbox;
